import {computed} from "@preact/signals-react";
import {appConfig} from "./app";


export const footerShowYear = computed(() => appConfig.value?.footer?.showYear ?? true)
export const footerText = computed(() => appConfig.value?.footer?.text || '© Designed and Developed by')
export const footerShowLink = computed(() => appConfig.value?.footer?.showLink ?? true)